export const blogs = [
    {
        title : "Writing Low-Level Designs: Principles, Patterns, and My Experience at Amazon",
        tags : ["LLD", "Amazon", "Writing tips"],
        image : "https://cdn.hashnode.com/res/hashnode/image/upload/v1747572110971/c44429fc-eb00-4b7c-ac7c-c106b97db93f.png?w=1600&h=840&fit=crop&crop=entropy&auto=compress,format&format=webp",
        url : "https://aayush-srivastava.hashnode.dev/writing-low-level-designs-principles-patterns-and-my-experience-at-amazon"
    },
    {
        title : "What is Cross-Site Scripting ?",
        tags : ["XSS", "XSS Attacks", "XSS Protection"],
        image : "https://cdn.hashnode.com/res/hashnode/image/upload/v1720116051477/48b78ce2-2e09-485e-bdcd-afe2b866dd6c.png",
        url : "https://aayush-srivastava.hashnode.dev/what-is-cross-site-scripting"
    },
    {
        title : "Optimizing Kafka Consumer by multi-threading in Python",
        tags : ["Kafka", "Python", "Threading"],
        image : "https://cdn.hashnode.com/res/hashnode/image/upload/v1718567003412/6845b01a-d163-48b2-a100-f13bc81d1342.png",
        url : "https://aayush-srivastava.hashnode.dev/optimizing-kafka-consumer-by-multi-threading-in-python"
    },
]